module.exports = __webpack_public_path__ + "img/call2.b18a33cc.svg";